import React from 'react';

import {
  GroupingByProjectEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/GroupingByProject/components/GroupingByProjectEntity';

export const GroupingByProject: React.FC = () => {
  return (
    <>
      <GroupingByProjectEntity complexName="complex name" />
    </>
  );
};
